if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: "0px 0px 400px 0px" }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations .list_cards_product");

          if (recommendations?.innerHTML.trim().length) {
            this.querySelector(".list_cards_product").innerHTML = recommendations.innerHTML;
            this.querySelector(".section_products_list_wrapper").style.display = "block";
          }

          // Si pas de recommandations, on supprime le parent
          if (!recommendations?.innerHTML.trim().length) {
            this.closest(".section_products_list_wrapper").remove();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  customElements.define("product-recommendations", ProductRecommendations);
}
